import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';

import type { GetAssetResponse } from '@blockworks/platform/api/research/assets';

import PriceChartDescription from '@/components/pages/price/components/content/about/price-chart-description';
import PriceInfoBlock from '@/components/pages/price/components/header/price-info-block';
import PricePageChart from '@/components/pages/price/components/price-page-chart';

interface PriceChartWithInfoProps {
    asset: GetAssetResponse['data'];
}
const PriceChartWithInfo = (props: PriceChartWithInfoProps): JSX.Element => {
    const { asset } = props;
    const router = useRouter();

    const [openPrice, setOpenPrice] = useState(asset?.price?.usd || 0);
    const [openPriceBtc, setOpenPriceBtc] = useState(asset?.price?.btc || 0);
    const [price, setPrice] = useState(asset?.price?.usd || 0);
    const [isBtc, setIsBtc] = useState(false);

    const PricePageChartComp = useMemo(
        () => (
            <PricePageChart
                asset={asset}
                setPrice={setPrice}
                setIsBtc={setIsBtc}
                setOpenPrice={setOpenPrice}
                setOpenPriceBtc={setOpenPriceBtc}
            />
        ),
        [asset],
    );
    const currentPrice = asset?.price?.usd || 0;

    // Refresh price in case user is on a price page and clicks on another asset in ticker
    useEffect(() => {
        setPrice(asset?.price?.usd || 0);
    }, [router.asPath]);

    return (
        <section className="p-8" onMouseLeave={() => setPrice(currentPrice)}>
            <PriceInfoBlock
                price={price}
                currentPrice={currentPrice}
                isBtc={isBtc}
                ohlcv24h={asset.ohlcv24h}
                openPrice={openPrice}
                openPriceBtc={openPriceBtc}
            />
            <div className="mt-8">{PricePageChartComp}</div>
            <PriceChartDescription asset={asset} />
        </section>
    );
};

export default PriceChartWithInfo;
